import { useId, useRef, type ReactNode } from 'react';

/** La explicación se abre al tocar; el diálogo nativo también permite cerrar con Escape. */
export function AyudaContextual({ titulo, children }: { titulo: string; children: ReactNode }) {
  const dialogo = useRef<HTMLDialogElement>(null);
  const id = useId();
  return <>
    <button type="button" aria-label={`Ayuda: ${titulo}`} aria-haspopup="dialog"
      onClick={() => dialogo.current?.showModal()}
      className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-(--color-acento) focus-visible:outline-2">
      <span className="flex h-6 w-6 items-center justify-center rounded-full border border-current text-sm font-bold" aria-hidden="true">?</span>
    </button>
    <dialog ref={dialogo} aria-labelledby={id}
      onClick={e => { if (e.target === e.currentTarget) dialogo.current?.close(); }}
      className="m-auto w-[calc(100%-2rem)] max-w-sm rounded-2xl border border-(--color-acento) bg-(--color-panel) p-5 text-(--color-texto) backdrop:bg-black/60">
      <h2 id={id} className="mb-3 font-titulo text-2xl">{titulo}</h2>
      <div className="text-sm leading-relaxed">{children}</div>
      <button type="button" onClick={() => dialogo.current?.close()}
        className="mt-5 min-h-11 w-full rounded-xl bg-(--color-acento) font-semibold text-(--color-sobre-acento)">Entendido</button>
    </dialog>
  </>;
}
